import { LoadingOutlined } from '@ant-design/icons';
import { Spin } from 'antd';

const Loading: React.FC = () => (
  <div
    role="status"
    aria-label="Loading page"
    style={{
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      minHeight: '100vh',
      width: '100%',
    }}
  >
    <Spin indicator={<LoadingOutlined spin />} size="large" />
  </div>
);

export default Loading;
